import { colors, fonts, fontSizes } from 'theme'
import measurements from 'theme/measurements'
import css from 'styled-jsx/css'

export const advantage = css`
 .container-advantage {
    max-width: ${measurements.containerSize};
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    background-color: ${colors.white};
    box-shadow: 0 8px 20px 0 rgba(197, 207, 222, 0.5);
    border-radius: ${measurements.borderRadius};
    position: relative;
    top: -41px;
    margin: 0 auto;
    flex-direction: row;
    overflow: auto;
 }
 
.advantage {
  display:flex;
  border-top: solid 1px ${colors.border};
  border-bottom: solid 1px ${colors.border};
  max-width: 17rem;
 }

.advantage:last-child {
  border-right: solid 1px ${colors.border};
  border-top-right-radius: ${measurements.borderRadius};
  border-bottom-right-radius: ${measurements.borderRadius};
 }
 
.advantage:first-child {
  border-left: solid 1px ${colors.border};
  border-top-left-radius: ${measurements.borderRadius};
  border-bottom-left-radius: ${measurements.borderRadius};
 }

 .advantage:hover, .advantage.active {
    background-color: ${colors.text};
    border-color: ${colors.text};
    transition: 400ms background-color, 400ms border;
 }
 
 .advantage:first-child:hover, .advantage:first-child.active {
    border-right: none;
 }
 
 .advantage:last-child:hover, .advantage:last-child.active {
    border-left: none;
 }
 
 .advantage:hover .advantage-link,
 .advantage.active .advantage-link {
  color:${colors.white};
 }

.advantage .advantage-link {
  color:${colors.text};
  text-align: center;
  font: ${fonts.semiBold};
  padding: 10px 1.1rem 20px;
 }

 .advantage-description {
   display: block;
 }

 @media screen and (max-width: 992px) {
  .container-advantage {
    flex-direction: column;
    padding: 2rem;
  }
  .container-advantage  .advantage{
    width: 100%;
    min-width: 100%;
    justify-content: center;
    border: none;
    border-top: solid 1px ${colors.border};

  }
  .advantage:hover, .advantage.active {
    border-radius: 0;
  }
}
`